import { CustomLink } from '../../custom-link';

import type { LinkProps } from 'next/link';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
  href?: LinkProps['href'];
  onClick?: () => void;
};

const navigationButtonStyles =
  'flex items-center w-full px-e py-d text-sm hover:bg-gray-50 sm:px-d sm:py-c lg:px-c lg:py-b';

export const NavigationButton = ({
  children,
  className,
  href,
  onClick,
}: Props) => {
  if (href) {
    return (
      <CustomLink
        className={`button ${navigationButtonStyles} ${className}`}
        href={href}
        confirmationRequired
        onClick={onClick}
      >
        {children}
      </CustomLink>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`font-semibold ${navigationButtonStyles} ${className}`}
    >
      {children}
    </button>
  );
};
